import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as browseService from '../../services/browseService';
import browseActionConstants from '../constants/browseActionConstants';
import globalActionConstants from '../constants/globalActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const getOpeningDetail = (openingId, currentUserId) => async (dispatch) => {
  const requestId = Date.now();
  dispatch({ type: browseActionConstants.SET_OPENING_DETAIL_REQUEST_ID, requestId });

  dispatch({ type: browseActionConstants.SET_OPENING_DETAILS_LOADING_ON });
  try {
    const response = await browseService.getOpeningDetail(openingId, currentUserId);

    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: browseActionConstants.GET_OPENINGS_DETAILS, payload: response.data.payload.opening, requestId });
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: browseActionConstants.SET_OPENING_DETAILS_LOADING_OFF });
  }
};

export const fetchNextOpenings = (data) => async (dispatch) => {
  dispatch({ type: browseActionConstants.SET_MORE_JOBS_LOADING_ON });

  try {
    const response = await browseService.getOpenings(data);

    if (response.data.response_code === responseCodes.OK) {
      const { payload } = response.data;
      dispatch({ type: browseActionConstants.FETCH_NEXT_OPENINGS, payload });
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: browseActionConstants.SET_MORE_JOBS_LOADING_OFF });
  }
};

export const getOpenings = (data, cb) => async (dispatch) => {
  const requestId = Date.now();
  dispatch({ type: browseActionConstants.SET_REQUEST_ID, requestId });

  dispatch({ type: browseActionConstants.SET_OPENING_LIST_LOADING_ON });
  try {
    const response = await browseService.getOpenings(data);
    if (response.data.response_code === responseCodes.OK) {
      const { payload } = response.data;
      if (payload?.jobs?.length > 0) {
        cb?.(payload.jobs[0]?.uuid);
      } else {
        const detailsRequestId = Date.now();
        dispatch({ type: browseActionConstants.SET_OPENING_DETAIL_REQUEST_ID, detailsRequestId });
        dispatch({ type: browseActionConstants.GET_OPENINGS_DETAILS, payload: {} });
      }
      dispatch({ type: browseActionConstants.GET_OPENINGS_SUCCESS, payload, requestId });
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: browseActionConstants.SET_OPENING_LIST_LOADING_OFF });
  }
};

export const getSearchOpenings = (data, searchOpenings) => async (dispatch) => {
  try {
    dispatch({ type: browseActionConstants.GET_SEARCH_OPENINGS_LOADING_ON });
    const response = await browseService.getOpenings(data);
    if (response.data.response_code === responseCodes.OK) {
      const { payload } = response.data;
      if (searchOpenings) {
        dispatch({ type: browseActionConstants.GET_SEARCH_OPENINGS_SUCCESS, payload });
      } else {
        Notification.error(response.data.error.message || response.data.error);
      }
    }
    dispatch({ type: browseActionConstants.GET_SEARCH_OPENINGS_LOADING_OFF });
  } catch (err) {
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const clearOpenings = () => async (dispatch) => {
  dispatch({ type: browseActionConstants.RESET_OPENINGS });
};

export const getReferralLink = (id) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await browseService.getReferralLink(id, 'job');
    if (response.data.response_code === responseCodes.OK) {
      return response.data.payload;
    }
    Notification.error(response.data.error.message || response.data.error);
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};

export const getCopyLink = (id) => async () => {
  try {
    const response = await browseService.getCopyLink(id);
    if (response.data.response_code === responseCodes.OK) {
      return response.data.payload;
    }
    Notification.error(response.data.error.message || response.data.error);
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const getSocialShareLink = (openingId) => async () => {
  try {
    const response = await browseService.getSocialShareLink(openingId);
    if (response.data.response_code === responseCodes.OK) {
      return response.data.payload;
    }
    Notification.error(response.data.error);
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const getSocialShareLinkCompany = (companyName) => async () => {
  try {
    const response = await browseService.getSocialShareLinkCompany(companyName);
    if (response.data.response_code === responseCodes.OK) {
      return response.data.payload;
    }
    Notification.error(response.data.error);
  } catch {
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const setSortby = (value) => async (dispatch) => {
  dispatch({ type: browseActionConstants.SET_SORTBY, payload: value });
};
